import React from 'react'
import CircularProgress from 'material-ui/CircularProgress'
const isXS = window.innerWidth < 767

const Loader = ({msg}) => (
  <div style={{
    zIndex:-999999,
    height:isXS?'300px':'500px',
    display:'flex',
    justifyContent:'center',
    alignItems:'center' }}>

    <CircularProgress size={60} thickness={4} />
    <span>{msg}</span>

  </div>
)

export default Loader



// WEBPACK FOOTER //
// ./src/components/Loader.jsx